<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-leak</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.icons') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <!-- <v-divider vertical  style="margin: 0 10px 0 10px;"/> -->
    </v-toolbar>
    <v-text-field
      v-if="!collapseContent"
      :label="$t('hsconsulting.hotel', locale)"
      v-model="content.HsconsultingHotelID"
    />
    <v-text-field
      v-if="!collapseContent"
      :label="$t('hsconsulting.installation', locale)"
      v-model="content.HsconsultingInstallationID"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['collapseContent', 'locale']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      }
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      }
    }
  }
</script>

<style scoped>
</style>

